import { useEffect, useState } from 'react';
import { getTaskOutbox } from '../local';
import type { OutboxStatus } from '../local/taskOutbox';

/** This account's queued task comments/files (B4), live. */
export function useTaskOutbox(): OutboxStatus {
  const [status, setStatus] = useState<OutboxStatus>(() => getTaskOutbox().getStatus());
  useEffect(() => getTaskOutbox().subscribe(setStatus), []);
  return status;
}
